import React from 'react';
import { Phone, Clock, Gift, Crown, UserPlus } from 'lucide-react';
import MaterialsList from './MaterialsList';
import ActionButtons from './ActionButtons';
import { getPremiumRemaining, getActivationTypeText } from '../utils/formatters';

const UserTable = ({ 
  users, 
  onView, 
  onEdit, 
  onGift, 
  onAccess, 
  onSubscribe, 
  onRevoke, 
  onDelete,
  getUserTrainingsList,
  getUserCoursesList,
  trainingsMap,
  coursesMap,
  expandedMaterials,
  toggleMaterialsExpand,
  getTrainingAccess,
  getCourseAccess
}) => {
  return (
    <div className="hidden md:block overflow-auto flex-1">
      <div className="min-w-full">
        <table className="w-full">
          <thead className="bg-gray-900/50 sticky top-0 z-20 border-b border-gray-700">
            <tr>
              <th className="py-2 px-3 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Пользователь</th>
              <th className="py-2 px-3 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Контакт</th>
              <th className="py-2 px-3 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Premium статус</th>
              <th className="py-2 px-3 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Тип активации</th>
              <th className="py-2 px-3 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Доступ к материалам</th>
              <th className="py-2 px-3 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Бонус</th>
              <th className="py-2 px-3 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Действия</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {users.map((user) => (
              <tr key={user.id} className="hover:bg-gray-700/30 transition-colors">
                <td className="py-2 px-3">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-900/50 to-purple-900/50 flex items-center justify-center flex-shrink-0 border border-gray-600">
                      {user.premium ? <Crown className="w-4 h-4 text-yellow-400" /> : <UserPlus className="w-4 h-4 text-gray-400" />}
                    </div>
                    <div className="min-w-0">
                      <div className="text-sm font-medium text-white truncate max-w-[120px]">{user.fullName || 'Без имени'}</div>
                      <div className="text-xs text-gray-400 truncate max-w-[120px]">@{user.username || 'без username'}</div>
                    </div>
                  </div>
                </td>
                <td className="py-2 px-3">
                  <div className="space-y-0.5 min-w-0">
                    {user.phone ? (
                      <div className="flex items-center gap-1 text-xs text-gray-300 truncate max-w-[140px]">
                        <Phone className="w-3 h-3 flex-shrink-0" />
                        <span className="truncate">{user.phone}</span>
                      </div>
                    ) : <span className="text-xs text-gray-500">—</span>}
                  </div>
                </td>
                <td className="py-2 px-3">
                  <div className="flex flex-col gap-1">
                    <div className={`px-2 py-0.5 rounded-full text-xs font-medium border w-fit ${
                      user.premium === true 
                        ? 'bg-yellow-900/30 text-yellow-300 border-yellow-700' 
                        : 'bg-gray-700/50 text-gray-300 border-gray-600'
                    }`}>
                      {user.premium === true ? 'Premium активен' : 'Без Premium'}
                    </div>
                    {user.premium === true && user.premiumExpiresAt && (
                      <div className="text-xs text-gray-400 flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        {getPremiumRemaining(user.premiumExpiresAt)}
                      </div>
                    )}
                  </div>
                </td>
                <td className="py-2 px-3">
                  {user.premium === true ? (
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-gray-300">
                        {getActivationTypeText(user.premiumActivationType)}
                      </span>
                      {user.subscription?.planName && (
                        <span className="text-xs text-gray-400 ml-1">
                          • {user.subscription.planName.replace('Premium ', '')}
                        </span>
                      )}
                    </div>
                  ) : (
                    <span className="text-xs text-gray-500">—</span>
                  )}
                </td>
                <td className="py-2 px-3">
                  <MaterialsList 
                    user={user}
                    getUserTrainingsList={getUserTrainingsList}
                    getUserCoursesList={getUserCoursesList}
                    trainingsMap={trainingsMap}
                    coursesMap={coursesMap}
                    expandedMaterials={expandedMaterials}
                    toggleMaterialsExpand={toggleMaterialsExpand}
                    getTrainingAccess={getTrainingAccess}
                    getCourseAccess={getCourseAccess}
                  />
                </td>
                <td className="py-2 px-3">
                  <div className="flex items-center gap-1">
                    <Gift className="w-3 h-3 text-green-400 flex-shrink-0" />
                    <span className="text-sm font-medium text-green-400 whitespace-nowrap">
                      {user.refBonus?.toLocaleString() || 0} €
                    </span>
                  </div>
                </td>
                <td className="py-2 px-3">
                  <ActionButtons 
                    user={user}
                    onView={onView}
                    onEdit={onEdit}
                    onGift={onGift}
                    onAccess={onAccess}
                    onSubscribe={onSubscribe}
                    onRevoke={onRevoke}
                    onDelete={onDelete}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserTable;